'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapRootElement = exports.onInitialClientRender = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactJss = require('react-jss');

var _CssBaseline = require('@material-ui/core/CssBaseline');

var _CssBaseline2 = _interopRequireDefault(_CssBaseline);

var _styles = require('@material-ui/core/styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Remove the server-side injected CSS.
var onInitialClientRender = exports.onInitialClientRender = function onInitialClientRender() {
  var ssStyles = window.document.getElementById('server-side-jss');
  ssStyles && ssStyles.parentNode.removeChild(ssStyles);
};

var defaultOptions = {
  theme: {},
  dangerouslyUseGlobalCSS: false,
  productionPrefix: 'jss'
};

var wrapRootElement = exports.wrapRootElement = function wrapRootElement(_ref) {
  var element = _ref.element;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
  var dangerouslyUseGlobalCSS = options.dangerouslyUseGlobalCSS,
      productionPrefix = options.productionPrefix,
      theme = options.theme;


  var generateClassName = (0, _styles.createGenerateClassName)({
    dangerouslyUseGlobalCSS: dangerouslyUseGlobalCSS,
    productionPrefix: productionPrefix
  });

  return _react2.default.createElement(
    _reactJss.JssProvider,
    { generateClassName: generateClassName },
    _react2.default.createElement(
      _styles.MuiThemeProvider,
      { theme: (0, _styles.createMuiTheme)(theme) },
      _react2.default.createElement(_CssBaseline2.default, null),
      element
    )
  );
};